import { __decorate, __metadata, __param } from "tslib";
import { backofficeUrlBase } from '@/config/envConfig';
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let DashboardApi = class DashboardApi {
    constructor(http) {
        this.http = http;
        this.baseUrl = backofficeUrlBase + '/backoffice/proxy/dashboard-service';
    }
    getDashboardInfo(params) {
        return this.http.get({
            url: `${this.baseUrl}/bo_dashboard_info`,
            params,
        });
    }
    getDashboardInfoStatus({ dashboard_id, public_admin }) {
        return this.http.get({
            url: `${this.baseUrl}/bo_dashboard_info/${dashboard_id}`,
            params: {
                public_admin,
            },
        });
    }
};
DashboardApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.DashboardHttp)),
    __metadata("design:paramtypes", [Object])
], DashboardApi);
export { DashboardApi };
